export default {
	Connect: "Connect",
	Disconect: "Disconect",
	ConnectWithPassword: "ConnectWithPassword",
};
